export const checkEmptyFields = ( field ) => {
	const val = field.value;

	field.form.classList.remove( 'sent', 'error', 'success' );
	
	if ( !field.classList.contains( 'select' ) )
	{
		if ( val.length === 0 || !field.form.querySelector( `input[name="${field.name}"]:checked` ) && ( field.type === 'checkbox' || field.type === 'radio' ) )
		{
			field.classList.add( 'empty' );
			field.classList.remove( 'not-empty' );
			field.closest( 'ul.fields > li' ).classList.add( 'empty' );
			field.closest( 'ul.fields > li' ).classList.remove( 'not-empty' );
		}
		else
		{
			field.classList.remove( 'empty' );
			field.classList.add( 'not-empty' );
			field.closest( 'ul.fields > li' ).classList.remove( 'empty' );
			field.closest( 'ul.fields > li' ).classList.add( 'not-empty' );
		}
	}
};
